import Axios from 'axios';
import { sendRequest } from './general';

export const getExportInterrupbles = async (params) => await sendRequest(Axios.get('/api/interruptible/daily-flow-per-day', { responseType: 'arraybuffer', params })); 